import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import TextTruncate from 'react-text-truncate';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';


class ProductNewRowItem extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { product } = this.props;
        const productSlug = `/app/products/${ product.desireid }/${ encodeForURI(product.title) }`;

        return (
            <div
            className={ `${ style.productRowItem } ${ this.props.className }` }
            style={ { ...this.props.style } }
            data-hook='product-row-item'>
                <Link to={ productSlug }>
                    <div className={ style.imageWrapper }>
                        <img src={ product.image } />
                    </div>
                    <div className={ style.details }>
                        <TextTruncate text={ product.title }
                        title={ product.title } line={ 3 }
                        containerClassName={ style.title } />
                    </div>
                </Link>
            </div>
        );
    }
}
ProductNewRowItem.propTypes = {
    product: PropTypes.object.isRequired,
};
ProductNewRowItem.defaultProps = {
    className: '',
};

export default ProductNewRowItem;
